// import React from "react";
// import {
//     Box, Typography, Button, CircularProgress, TextField, Chip, Checkbox,
//     Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
//     MenuItem, Select, FormControl,
// } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
// import {
//     FB, FB_DARK, FB_LIGHT, FB_MID, SURFACE, BG, BORDER, T1, T2,
//     G200, G300, G500, G700, G900, WHITE,
//     REPORT_TYPES, BOOK_NAMES,
//     btnGhostSx, btnPrimarySx, inputSx, selectSx,
// } from "./ReportDetailsConstants";
// import { fmtDate } from "./LedgerDetailsHelpers";

// // ─── Smart Filter Dialog ──────────────────────────────────────────────────────
// export default function SmartFilterDialog({
//     open, onClose, allClients, itemGroupsLoading, tempFromDate, setTempFromDate,
//     tempToDate, setTempToDate, tempClientSearchText, setTempClientSearchText, tempSelectedClients,
//     setTempSelectedClients, filteredTempClients, handleTempSelectAll, handleTempDeselectAll, handleTempClientCheckbox,
//     loading, onGetData, tempReportType, setTempReportType, selectedBookNames,
//     setSelectedBookNames, selectedBankAccount, setSelectedBankAccount, bankAccounts, bankAccountsLoading, isDaywise, setIsDaywise,
// }) {
//     const showClientSection = tempReportType === "general_ledger";
//     const showBankFields = tempReportType === "bank_book";

//     const isGetDataDisabled =
//         loading ||
//         (showClientSection && tempSelectedClients.length === 0) ||
//         (showBankFields && !selectedBankAccount) ||
//         !tempFromDate ||
//         !tempToDate;

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//             PaperProps={{ sx: { borderRadius: "10px", border: `1px solid ${G300}`, boxShadow: "0 8px 40px rgba(0,0,0,0.12)" } }}
//         >
//             {/* ── Dialog Title ── */}
//             <DialogTitle sx={{ p: 0 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.75, borderBottom: `1px solid ${G300}` }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{ width: 3, height: 22, background: FB, borderRadius: 2 }} />
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 700, color: G900, lineHeight: 1 }}>Smart Filter</Typography>
//                             <Typography sx={{ fontSize: 11, color: G500, mt: "2px" }}>Configure report parameters</Typography>
//                         </Box>
//                     </Box>
//                     <IconButton onClick={onClose} size="small" sx={{ color: G500, "&:hover": { background: G200 } }}>
//                         <CloseIcon sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             {/* ── Dialog Content ── */}
//             <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1 }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

//                     {/* ── Report Type Dropdown ── */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
//                             Report Type
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                             <Select value={tempReportType} onChange={(e) => setTempReportType(e.target.value)} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
//                                 MenuProps={{
//                                     PaperProps: {
//                                         sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5, },
//                                     },
//                                 }}
//                             >
//                                 {REPORT_TYPES.map((rt) => (
//                                     <MenuItem
//                                         key={rt.value}
//                                         value={rt.value}
//                                         sx={{
//                                             fontSize: 13, fontFamily: "'DM Sans', sans-serif", color: T1, fontWeight: tempReportType === rt.value ? 600 : 400, background: tempReportType === rt.value ? FB_LIGHT : "transparent",
//                                             "&:hover": { background: FB_LIGHT },
//                                             "&.Mui-selected": {
//                                                 background: FB_LIGHT, color: FB,
//                                                 "&:hover": { background: FB_LIGHT },
//                                             },
//                                             borderRadius: "6px",
//                                             mx: 0.5,
//                                             my: 0.25,
//                                         }}
//                                     >
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempReportType === rt.value ? FB : BORDER, flexShrink: 0, transition: "background .2s", }} />
//                                             {rt.label}
//                                         </Box>
//                                     </MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>

//                         {tempReportType && (
//                             <Box
//                                 sx={{ mt: 1, display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: FB_LIGHT, border: `1px solid ${FB_MID}`, borderRadius: "20px", }} >
//                                 <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: FB_DARK }} >
//                                     {REPORT_TYPES.find((r) => r.value === tempReportType)?.label}
//                                 </Typography>
//                             </Box>
//                         )}
//                     </Box>

//                     {/* ── Divider ── */}
//                     <Box sx={{ height: "1px", background: BORDER, mx: -0.5 }} />

//                     {/* ── Book Name — hidden for Groupwise Summary ── */}
//                     {tempReportType !== "group_wise_summary" && (
//                         <Box>
//                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }} >
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                     Book Name
//                                 </Typography>

//                                 {selectedBookNames.length > 0 && (
//                                     <Typography onClick={() => setSelectedBookNames([])}
//                                         sx={{
//                                             fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer",
//                                             "&:hover": { textDecoration: "underline" }
//                                         }}
//                                     >
//                                         Clear
//                                     </Typography>
//                                 )}
//                             </Box>

//                             <FormControl fullWidth size="small">
//                                 <Select multiple displayEmpty value={selectedBookNames}
//                                     renderValue={(selected) => {
//                                         if (selected.length === 0) {
//                                             return (
//                                                 <Typography sx={{ color: T2, fontSize: 13 }} >
//                                                     Select All
//                                                 </Typography>
//                                             );
//                                         }

//                                         return (
//                                             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} >
//                                                 {selected.map((value) => (
//                                                     <Chip key={value} label={value} size="small" sx={{ height: 22, fontSize: 11, background: FB_LIGHT, color: FB, border: `1px solid ${G300}` }} />
//                                                 ))}
//                                             </Box>
//                                         );
//                                     }}
//                                     sx={selectSx}
//                                     MenuProps={{
//                                         PaperProps: {
//                                             sx: { maxHeight: 300, borderRadius: "10px", border: `1px solid ${BORDER}` }
//                                         }
//                                     }}
//                                 >
//                                     {BOOK_NAMES.map((name) => (
//                                         <MenuItem key={name} value={name}
//                                             onClick={() => {
//                                                 setSelectedBookNames((prev) =>
//                                                     prev.includes(name)
//                                                         ? prev.filter((n) => n !== name)
//                                                         : [...prev, name]
//                                                 );
//                                             }}
//                                         >
//                                             <Checkbox
//                                                 checked={selectedBookNames.includes(name)}
//                                                 sx={{
//                                                     color: FB_MID,
//                                                     "&.Mui-checked": { color: FB }
//                                                 }}
//                                             />

//                                             <Typography sx={{ fontSize: 12, fontFamily: "'DM Mono', monospace" }} >
//                                                 {name}
//                                             </Typography>
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                         </Box>
//                     )}

//                     {/* ── Bank Account — only for BankBook ── */}
//                     {showBankFields && (
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
//                                 Bank Account
//                             </Typography>
//                             <Select fullWidth size="small" value={selectedBankAccount} onChange={(e) => setSelectedBankAccount(e.target.value)} sx={selectSx} >
//                                 <MenuItem value="">Select Bank Account</MenuItem>
//                                 {bankAccountsLoading ? (
//                                     <MenuItem disabled>
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                             <CircularProgress size={16} />
//                                             <Typography sx={{ fontSize: 12 }}>Loading...</Typography>
//                                         </Box>
//                                     </MenuItem>
//                                 ) : bankAccounts.length > 0 ? (
//                                     bankAccounts.map((account) => (
//                                         <MenuItem key={account.id} value={account.id}>
//                                             {account.AccountName}{account.AccountNumber ? ` - ${account.AccountNumber}` : ''}
//                                         </MenuItem>
//                                     ))
//                                 ) : (
//                                     <MenuItem disabled>
//                                         <Typography sx={{ fontSize: 12, color: T2 }}>No accounts found</Typography>
//                                     </MenuItem>
//                                 )}
//                             </Select>
//                         </Box>
//                     )}

//                     {/* ── From Date ── */}
//                     <Box>
//                         <Typography
//                             sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
//                             From Date
//                         </Typography>
//                         <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
//                     </Box>

//                     {/* ── To Date ── */}
//                     <Box>
//                         <Typography
//                             sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
//                             To Date
//                         </Typography>
//                         <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
//                     </Box>

//                     {(tempReportType === "bank_book" || tempReportType === "cash_book") && (
//                         <Box>
//                             <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
//                                 Options
//                             </Typography>
//                             <Box onClick={() => setIsDaywise((prev) => !prev)}
//                                 sx={{
//                                     display: "flex", alignItems: "center", justifyContent: "space-between", px: 1.5, py: 1.25, borderRadius: "10px", background: isDaywise ? FB_LIGHT : BG, border: `1.5px solid ${isDaywise ? FB : BORDER}`, cursor: "pointer", transition: "all .2s",
//                                     "&:hover": { borderColor: FB_MID, background: FB_LIGHT, },
//                                 }}
//                             >
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                     <Box sx={{ width: 32, height: 32, borderRadius: "8px", background: isDaywise ? FB : `${T2}18`, display: "flex", alignItems: "center", justifyContent: "center", transition: "background .2s", flexShrink: 0, }} >
//                                         <CalendarTodayOutlinedIcon sx={{ fontSize: 15, color: isDaywise ? "#fff" : T2, transition: "color .2s", }} />
//                                     </Box>
//                                     <Box>
//                                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDaywise ? FB_DARK : T1, lineHeight: 1.2, }} >
//                                             Daywise
//                                         </Typography>
//                                         <Typography sx={{ fontSize: 11, color: T2, lineHeight: 1.2, }} >
//                                             Group entries by date
//                                         </Typography>
//                                     </Box>
//                                 </Box>

//                                 <Checkbox checked={isDaywise} onChange={(e) => { e.stopPropagation(); setIsDaywise(e.target.checked); }}
//                                     sx={{
//                                         color: FB_MID,
//                                         "&.Mui-checked": { color: FB },
//                                         p: "4px",
//                                     }}
//                                 />
//                             </Box>
//                         </Box>
//                     )}

//                     {/* ── General Ledger: Client Search + Selection ── */}
//                     {showClientSection && (
//                         <>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
//                                     Search Clients
//                                 </Typography>
//                                 <TextField fullWidth size="small" placeholder="Search by name, code, or contact..." value={tempClientSearchText} onChange={(e) => setTempClientSearchText(e.target.value)} sx={inputSx} InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
//                             </Box>

//                             <Box>
//                                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase", }} >
//                                         Select Clients ({tempSelectedClients.length} /{" "}
//                                         {allClients.length})
//                                     </Typography>
//                                 </Box>

//                                 <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "8px", background: BG, maxHeight: 250, overflowY: "auto", }} >
//                                     <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "8px", borderBottom: `1px solid ${BORDER}`, background: FB_LIGHT, position: "sticky", top: 0, zIndex: 1, }} >
//                                         <Checkbox
//                                             size="small"
//                                             checked={
//                                                 tempSelectedClients.length ===
//                                                 filteredTempClients.length &&
//                                                 filteredTempClients.length > 0
//                                             }
//                                             indeterminate={
//                                                 tempSelectedClients.length > 0 &&
//                                                 tempSelectedClients.length < filteredTempClients.length
//                                             }
//                                             onChange={() => {
//                                                 if (tempSelectedClients.length === filteredTempClients.length) {
//                                                     setTempSelectedClients([]);
//                                                 } else {
//                                                     setTempSelectedClients([
//                                                         ...tempSelectedClients,
//                                                         ...filteredTempClients.filter(
//                                                             (c) => !tempSelectedClients.some((s) => s.id === c.id)
//                                                         ),
//                                                     ]);
//                                                 }
//                                             }}
//                                             sx={{
//                                                 color: FB_MID,
//                                                 "&.Mui-checked": { color: FB },
//                                                 "&.MuiCheckbox-indeterminate": { color: FB },
//                                                 p: "4px",
//                                             }}
//                                         />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
//                                             Select All ({filteredTempClients.length})
//                                         </Typography>
//                                     </Box>

//                                     {filteredTempClients.length === 0 ? (
//                                         <Box sx={{ px: 2, py: 2, textAlign: "center" }}>
//                                             <Typography sx={{ fontSize: 12, color: T2 }}>
//                                                 No clients found
//                                             </Typography>
//                                         </Box>
//                                     ) : (
//                                         filteredTempClients.map((client) => {
//                                             const isSelected = tempSelectedClients.some((c) => c.id === client.id);
//                                             return (
//                                                 <Box key={client.id} sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${BORDER}`, background: isSelected ? FB_LIGHT : "transparent", }} onClick={() => handleTempClientCheckbox(client)} >
//                                                     <Checkbox size="small" checked={isSelected} onChange={() => handleTempClientCheckbox(client)} onClick={(e) => e.stopPropagation()}
//                                                         sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px", }}
//                                                     />
//                                                     <Box sx={{ minWidth: 0, flex: 1 }}>
//                                                         <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500, }}>
//                                                             {client.FirmName}
//                                                         </Typography>
//                                                     </Box>
//                                                 </Box>
//                                             );
//                                         })
//                                     )}
//                                 </Box>
//                             </Box>
//                         </>
//                     )}

//                     {/* ── Preview ── */}
//                     {tempFromDate &&
//                         tempToDate &&
//                         (showClientSection ? tempSelectedClients.length > 0 : true) &&
//                         (showBankFields ? !!selectedBankAccount : true) && (
//                             <Box sx={{ background: FB_LIGHT, border: `1px solid ${G300}`, borderRadius: "10px", p: "10px 14px", display: "flex", flexDirection: "column", gap: "6px" }}>
//                                 <Typography sx={{ fontSize: 11, fontWeight: 600, color: G500, textTransform: "uppercase", letterSpacing: ".3px" }}>Preview</Typography>
//                                 <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
//                                     <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
//                                         <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>{REPORT_TYPES.find((r) => r.value === tempReportType)?.label}</Typography>
//                                     </Box>
//                                     <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
//                                         <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>{fmtDate(tempFromDate)} – {fmtDate(tempToDate)}</Typography>
//                                     </Box>
//                                     {showClientSection && tempSelectedClients.length > 0 && (
//                                         <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
//                                             <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>{tempSelectedClients.length} client{tempSelectedClients.length > 1 ? "s" : ""}</Typography>
//                                         </Box>
//                                     )}

//                                     {selectedBookNames.length > 0 && (
//                                         <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }} >
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
//                                             <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
//                                                 {selectedBookNames.length === 1 ? selectedBookNames[0] : `${selectedBookNames.length} books`}
//                                             </Typography>
//                                         </Box>
//                                     )}

//                                     {showBankFields && selectedBankAccount && (
//                                         <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }} >
//                                             <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
//                                             <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
//                                                 {bankAccounts.find((a) => a.id === selectedBankAccount)?.AccountName || 'Bank Account'}
//                                             </Typography>
//                                         </Box>
//                                     )}
//                                 </Box>
//                             </Box>
//                         )}
//                 </Box>
//             </DialogContent>

//             {/* ── Dialog Actions ── */}
//             <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
//                 <Button onClick={onClose} sx={btnGhostSx} fullWidth>
//                     Cancel
//                 </Button>
//                 <Button onClick={onGetData} disabled={isGetDataDisabled}
//                     startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
//                     sx={btnPrimarySx} fullWidth
//                 >
//                     Get Data
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }




import { colors as themeColors } from '../utils/theme';
import React from "react";
import {
    Box, Typography, Button, CircularProgress, TextField, Chip, Checkbox,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
    MenuItem, Select, FormControl, ListSubheader,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import {
    FB, FB_DARK, FB_LIGHT, FB_MID, SURFACE, BG, BORDER, T1, T2,
    G200, G300, G500, G700, G900, WHITE,
    REPORT_TYPES, BOOK_NAMES,
    btnGhostSx, btnPrimarySx, inputSx, selectSx,
} from "./ReportDetailsConstants";
import { fmtDate } from "./LedgerDetailsHelpers";

// ─── Smart Filter Dialog ──────────────────────────────────────────────────────
export default function SmartFilterDialog({
    open, onClose, allClients, itemGroupsLoading, tempFromDate, setTempFromDate,
    tempToDate, setTempToDate, tempClientSearchText, setTempClientSearchText, tempSelectedClients,
    setTempSelectedClients, filteredTempClients, handleTempSelectAll, handleTempDeselectAll, handleTempClientCheckbox,
    loading, onGetData, tempReportType, setTempReportType, selectedBookNames,
    setSelectedBookNames, selectedBankAccount, setSelectedBankAccount, bankAccounts, bankAccountsLoading, isDaywise, setIsDaywise,
    // Sale VS Purchase props
    allSalesAccountClients, salesClientsLoading, tempSelectedSalesClients, setTempSelectedSalesClients,
    salesClientSearchText, setSalesClientSearchText,
    allPurchaseAccountClients, purchaseClientsLoading, tempSelectedPurchaseClients, setTempSelectedPurchaseClients,
    purchaseClientSearchText, setPurchaseClientSearchText,
    // Inc. VS Exp. props
    allIncomeAccountClients, incomeClientsLoading, tempSelectedIncomeClients, setTempSelectedIncomeClients,
    incomeClientSearchText, setIncomeClientSearchText,
    allExpenseAccountClients, expenseClientsLoading, tempSelectedExpenseClients, setTempSelectedExpenseClients,
    expenseClientSearchText, setExpenseClientSearchText,
}) {
    const showClientSection = tempReportType === "general_ledger";
    const showBankFields = tempReportType === "bank_book";
    const showSaleVsPurchase = tempReportType === "sale_vs_purchase";
    const showIncVsExp = tempReportType === "inc_vs_exp";

    const filteredSalesClients = (allSalesAccountClients || []).filter(c =>
        !salesClientSearchText || c.FirmName?.toLowerCase().includes(salesClientSearchText.toLowerCase())
    );
    const filteredPurchaseClients = (allPurchaseAccountClients || []).filter(c =>
        !purchaseClientSearchText || c.FirmName?.toLowerCase().includes(purchaseClientSearchText.toLowerCase())
    );
    const filteredIncomeClients = (allIncomeAccountClients || []).filter(c =>
        !incomeClientSearchText || c.FirmName?.toLowerCase().includes(incomeClientSearchText.toLowerCase())
    );
    const filteredExpenseClients = (allExpenseAccountClients || []).filter(c =>
        !expenseClientSearchText || c.FirmName?.toLowerCase().includes(expenseClientSearchText.toLowerCase())
    );

    const isGetDataDisabled =
        loading ||
        (showBankFields && !selectedBankAccount) ||
        // Sale VS Purchase: at least one Sales client AND one Purchase client must be selected
        (showSaleVsPurchase && (
            !(tempSelectedSalesClients && tempSelectedSalesClients.length > 0) ||
            !(tempSelectedPurchaseClients && tempSelectedPurchaseClients.length > 0)
        )) ||
        // Inc. VS Exp.: at least one Income client AND one Expense client must be selected
        (showIncVsExp && (
            !(tempSelectedIncomeClients && tempSelectedIncomeClients.length > 0) ||
            !(tempSelectedExpenseClients && tempSelectedExpenseClients.length > 0)
        )) ||
        !tempFromDate ||
        !tempToDate;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: "10px", border: `1px solid ${G300}`, boxShadow: "0 8px 40px rgba(0,0,0,0.12)" } }}
        >
            {/* ── Dialog Title ── */}
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.75, borderBottom: `1px solid ${G300}` }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box sx={{ width: 3, height: 22, background: FB, borderRadius: 2 }} />
                        <Box>
                            <Typography sx={{ fontSize: 14, fontWeight: 700, color: G900, lineHeight: 1 }}>Smart Filter</Typography>
                            <Typography sx={{ fontSize: 11, color: G500, mt: "2px" }}>Configure report parameters</Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={onClose} size="small" sx={{ color: G500, "&:hover": { background: G200 } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* ── Dialog Content ── */}
            <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 1 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                    {/* ── Report Type Dropdown ── */}
                    <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
                            Report Type
                        </Typography>
                        <FormControl fullWidth size="small">
                            <Select disabled value={tempReportType} onChange={(e) => setTempReportType(e.target.value)} displayEmpty IconComponent={KeyboardArrowDownIcon} sx={selectSx}
                                MenuProps={{
                                    PaperProps: {
                                        sx: { borderRadius: "10px", border: `1px solid ${BORDER}`, boxShadow: "0 4px 20px rgba(24,119,242,0.12)", mt: 0.5, },
                                    },
                                }}
                            >
                                {REPORT_TYPES.map((rt) => (
                                    <MenuItem
                                        key={rt.value}
                                        value={rt.value}
                                        sx={{
                                            fontSize: 13, fontFamily: "'DM Sans', sans-serif", color: T1, fontWeight: tempReportType === rt.value ? 600 : 400, background: tempReportType === rt.value ? FB_LIGHT : "transparent",
                                            "&:hover": { background: FB_LIGHT },
                                            "&.Mui-selected": {
                                                background: FB_LIGHT, color: FB,
                                                "&:hover": { background: FB_LIGHT },
                                            },
                                            borderRadius: "6px",
                                            mx: 0.5,
                                            my: 0.25,
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: tempReportType === rt.value ? FB : BORDER, flexShrink: 0, transition: "background .2s", }} />
                                            {rt.label}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {tempReportType && (
                            <Box
                                sx={{ mt: 1, display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: FB_LIGHT, border: `1px solid ${FB_MID}`, borderRadius: "20px", }} >
                                <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: FB_DARK }} >
                                    {REPORT_TYPES.find((r) => r.value === tempReportType)?.label}
                                </Typography>
                            </Box>
                        )}
                    </Box>

                    {/* ── Divider ── */}
                    <Box sx={{ height: "1px", background: BORDER, mx: -0.5 }} />

                    {/* ── Bank Account — only for BankBook ── */}
                    {showBankFields && (
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                                Bank Account
                            </Typography>
                            <Select fullWidth size="small" value={selectedBankAccount} onChange={(e) => setSelectedBankAccount(e.target.value)} sx={selectSx} >
                                <MenuItem value="">Select Bank Account</MenuItem>
                                {bankAccountsLoading ? (
                                    <MenuItem disabled>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={16} />
                                            <Typography sx={{ fontSize: 12 }}>Loading...</Typography>
                                        </Box>
                                    </MenuItem>
                                ) : bankAccounts.length > 0 ? (
                                    bankAccounts.map((account) => (
                                        <MenuItem key={account.id} value={account.id}>
                                            {account.AccountName}{account.AccountNumber ? ` - ${account.AccountNumber}` : ''}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>
                                        <Typography sx={{ fontSize: 12, color: T2 }}>No accounts found</Typography>
                                    </MenuItem>
                                )}
                            </Select>
                        </Box>
                    )}

                    {/* ── Book Name + From Date + To Date — in ONE row ── */}
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                    {tempReportType !== "group_wise_summary" && tempReportType !== "sale_vs_purchase" && tempReportType !== "inc_vs_exp" && (
                        <Box sx={{ flex: 1.8, minWidth: 0 }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }} >
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Book Name
                                </Typography>

                                {selectedBookNames.length > 0 && (
                                    <Typography onClick={() => setSelectedBookNames([])}
                                        sx={{
                                            fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer",
                                            "&:hover": { textDecoration: "underline" }
                                        }}
                                    >
                                        Clear
                                    </Typography>
                                )}
                            </Box>

                            <FormControl fullWidth size="small">
                                <Select multiple displayEmpty value={selectedBookNames}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return (
                                                <Typography sx={{ color: T2, fontSize: 13 }} >
                                                    Select All
                                                </Typography>
                                            );
                                        }

                                        return (
                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} >
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} size="small" sx={{ height: 22, fontSize: 11, background: FB_LIGHT, color: FB, border: `1px solid ${G300}` }} />
                                                ))}
                                            </Box>
                                        );
                                    }}
                                    sx={selectSx}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: { maxHeight: 300, borderRadius: "10px", border: `1px solid ${BORDER}` }
                                        }
                                    }}
                                >
                                    {BOOK_NAMES.map((name) => (
                                        <MenuItem key={name} value={name}
                                            onClick={() => {
                                                setSelectedBookNames((prev) =>
                                                    prev.includes(name)
                                                        ? prev.filter((n) => n !== name)
                                                        : [...prev, name]
                                                );
                                            }}
                                        >
                                            <Checkbox
                                                checked={selectedBookNames.includes(name)}
                                                sx={{
                                                    color: FB_MID,
                                                    "&.Mui-checked": { color: FB }
                                                }}
                                            />

                                            <Typography sx={{ fontSize: 12, fontFamily: "'DM Mono', monospace" }} >
                                                {name}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}

                    {/* ── From Date ── */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
                            From Date
                        </Typography>
                        <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
                    </Box>

                    {/* ── To Date ── */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
                            To Date
                        </Typography>
                        <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
                    </Box>
                    </Box>

                    {(tempReportType === "bank_book" || tempReportType === "cash_book") && (
                        <Box>
                            <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase", }} >
                                Options
                            </Typography>
                            <Box onClick={() => setIsDaywise((prev) => !prev)}
                                sx={{
                                    display: "flex", alignItems: "center", justifyContent: "space-between", px: 1.5, py: 1.25, borderRadius: "10px", background: isDaywise ? FB_LIGHT : BG, border: `1.5px solid ${isDaywise ? FB : BORDER}`, cursor: "pointer", transition: "all .2s",
                                    "&:hover": { borderColor: FB_MID, background: FB_LIGHT, },
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: "8px", background: isDaywise ? FB : `${T2}18`, display: "flex", alignItems: "center", justifyContent: "center", transition: "background .2s", flexShrink: 0, }} >
                                        <CalendarTodayOutlinedIcon sx={{ fontSize: 15, color: isDaywise ? themeColors.neutral.surface : T2, transition: "color .2s", }} />
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDaywise ? FB_DARK : T1, lineHeight: 1.2, }} >
                                            Daywise
                                        </Typography>
                                        <Typography sx={{ fontSize: 11, color: T2, lineHeight: 1.2, }} >
                                            Group entries by date
                                        </Typography>
                                    </Box>
                                </Box>

                                <Checkbox checked={isDaywise} onChange={(e) => { e.stopPropagation(); setIsDaywise(e.target.checked); }}
                                    sx={{
                                        color: FB_MID,
                                        "&.Mui-checked": { color: FB },
                                        p: "4px",
                                    }}
                                />
                            </Box>
                        </Box>
                    )}

                    {/* ── Sale VS Purchase: Sales Accounts Clients ── */}
                    {showSaleVsPurchase && (
                        <>
                            <Box>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Sales Accounts Clients
                                </Typography>
                                <TextField fullWidth size="small" placeholder="Search sales clients..." value={salesClientSearchText || ""} onChange={(e) => setSalesClientSearchText(e.target.value)} sx={inputSx} InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                        Select Sales Clients ({(tempSelectedSalesClients || []).length} / {(allSalesAccountClients || []).length})
                                    </Typography>
                                </Box>
                                <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "8px", background: BG, maxHeight: 200, overflowY: "auto" }}>
                                    {salesClientsLoading ? (
                                        <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={14} sx={{ color: FB }} />
                                            <Typography sx={{ fontSize: 12, color: T2 }}>Loading…</Typography>
                                        </Box>
                                    ) : (
                                        <>
                                            <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "8px", borderBottom: `1px solid ${BORDER}`, background: FB_LIGHT, position: "sticky", top: 0, zIndex: 1 }}>
                                                <Checkbox size="small"
                                                    checked={(tempSelectedSalesClients || []).length === filteredSalesClients.length && filteredSalesClients.length > 0}
                                                    indeterminate={(tempSelectedSalesClients || []).length > 0 && (tempSelectedSalesClients || []).length < filteredSalesClients.length}
                                                    onChange={() => {
                                                        if ((tempSelectedSalesClients || []).length === filteredSalesClients.length) {
                                                            setTempSelectedSalesClients([]);
                                                        } else {
                                                            setTempSelectedSalesClients([
                                                                ...(tempSelectedSalesClients || []),
                                                                ...filteredSalesClients.filter(c => !(tempSelectedSalesClients || []).some(s => s.id === c.id)),
                                                            ]);
                                                        }
                                                    }}
                                                    sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
                                                />
                                                <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({filteredSalesClients.length})</Typography>
                                            </Box>
                                            {filteredSalesClients.length === 0 ? (
                                                <Box sx={{ px: 2, py: 2, textAlign: "center" }}><Typography sx={{ fontSize: 12, color: T2 }}>No clients found</Typography></Box>
                                            ) : filteredSalesClients.map((client) => {
                                                const isSelected = (tempSelectedSalesClients || []).some(c => c.id === client.id);
                                                return (
                                                    <Box key={client.id} sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${BORDER}`, background: isSelected ? FB_LIGHT : "transparent" }}
                                                        onClick={() => setTempSelectedSalesClients(prev => isSelected ? prev.filter(c => c.id !== client.id) : [...prev, client])}>
                                                        <Checkbox size="small" checked={isSelected} onChange={() => {}} sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }} />
                                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500 }}>{client.FirmName}</Typography>
                                                    </Box>
                                                );
                                            })}
                                        </>
                                    )}
                                </Box>
                            </Box>

                            {/* ── Purchase Accounts Clients ── */}
                            <Box>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Purchase Accounts Clients
                                </Typography>
                                <TextField fullWidth size="small" placeholder="Search purchase clients..." value={purchaseClientSearchText || ""} onChange={(e) => setPurchaseClientSearchText(e.target.value)} sx={inputSx} InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                        Select Purchase Clients ({(tempSelectedPurchaseClients || []).length} / {(allPurchaseAccountClients || []).length})
                                    </Typography>
                                </Box>
                                <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "8px", background: BG, maxHeight: 200, overflowY: "auto" }}>
                                    {purchaseClientsLoading ? (
                                        <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={14} sx={{ color: FB }} />
                                            <Typography sx={{ fontSize: 12, color: T2 }}>Loading…</Typography>
                                        </Box>
                                    ) : (
                                        <>
                                            <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "8px", borderBottom: `1px solid ${BORDER}`, background: FB_LIGHT, position: "sticky", top: 0, zIndex: 1 }}>
                                                <Checkbox size="small"
                                                    checked={(tempSelectedPurchaseClients || []).length === filteredPurchaseClients.length && filteredPurchaseClients.length > 0}
                                                    indeterminate={(tempSelectedPurchaseClients || []).length > 0 && (tempSelectedPurchaseClients || []).length < filteredPurchaseClients.length}
                                                    onChange={() => {
                                                        if ((tempSelectedPurchaseClients || []).length === filteredPurchaseClients.length) {
                                                            setTempSelectedPurchaseClients([]);
                                                        } else {
                                                            setTempSelectedPurchaseClients([
                                                                ...(tempSelectedPurchaseClients || []),
                                                                ...filteredPurchaseClients.filter(c => !(tempSelectedPurchaseClients || []).some(s => s.id === c.id)),
                                                            ]);
                                                        }
                                                    }}
                                                    sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
                                                />
                                                <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({filteredPurchaseClients.length})</Typography>
                                            </Box>
                                            {filteredPurchaseClients.length === 0 ? (
                                                <Box sx={{ px: 2, py: 2, textAlign: "center" }}><Typography sx={{ fontSize: 12, color: T2 }}>No clients found</Typography></Box>
                                            ) : filteredPurchaseClients.map((client) => {
                                                const isSelected = (tempSelectedPurchaseClients || []).some(c => c.id === client.id);
                                                return (
                                                    <Box key={client.id} sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${BORDER}`, background: isSelected ? FB_LIGHT : "transparent" }}
                                                        onClick={() => setTempSelectedPurchaseClients(prev => isSelected ? prev.filter(c => c.id !== client.id) : [...prev, client])}>
                                                        <Checkbox size="small" checked={isSelected} onChange={() => {}} sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }} />
                                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500 }}>{client.FirmName}</Typography>
                                                    </Box>
                                                );
                                            })}
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </>
                    )}

                    {/* ── Inc. VS Exp.: Income Accounts Clients ── */}
                    {showIncVsExp && (
                        <>
                            <Box>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Income Accounts Clients
                                </Typography>
                                <TextField fullWidth size="small" placeholder="Search income clients..." value={incomeClientSearchText || ""} onChange={(e) => setIncomeClientSearchText(e.target.value)} sx={inputSx} InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                        Select Income Clients ({(tempSelectedIncomeClients || []).length} / {(allIncomeAccountClients || []).length})
                                    </Typography>
                                </Box>
                                <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "8px", background: BG, maxHeight: 200, overflowY: "auto" }}>
                                    {incomeClientsLoading ? (
                                        <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={14} sx={{ color: FB }} />
                                            <Typography sx={{ fontSize: 12, color: T2 }}>Loading…</Typography>
                                        </Box>
                                    ) : (
                                        <>
                                            <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "8px", borderBottom: `1px solid ${BORDER}`, background: FB_LIGHT, position: "sticky", top: 0, zIndex: 1 }}>
                                                <Checkbox size="small"
                                                    checked={(tempSelectedIncomeClients || []).length === filteredIncomeClients.length && filteredIncomeClients.length > 0}
                                                    indeterminate={(tempSelectedIncomeClients || []).length > 0 && (tempSelectedIncomeClients || []).length < filteredIncomeClients.length}
                                                    onChange={() => {
                                                        if ((tempSelectedIncomeClients || []).length === filteredIncomeClients.length) {
                                                            setTempSelectedIncomeClients([]);
                                                        } else {
                                                            setTempSelectedIncomeClients([
                                                                ...(tempSelectedIncomeClients || []),
                                                                ...filteredIncomeClients.filter(c => !(tempSelectedIncomeClients || []).some(s => s.id === c.id)),
                                                            ]);
                                                        }
                                                    }}
                                                    sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
                                                />
                                                <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({filteredIncomeClients.length})</Typography>
                                            </Box>
                                            {filteredIncomeClients.length === 0 ? (
                                                <Box sx={{ px: 2, py: 2, textAlign: "center" }}><Typography sx={{ fontSize: 12, color: T2 }}>No clients found</Typography></Box>
                                            ) : filteredIncomeClients.map((client) => {
                                                const isSelected = (tempSelectedIncomeClients || []).some(c => c.id === client.id);
                                                return (
                                                    <Box key={client.id} sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${BORDER}`, background: isSelected ? FB_LIGHT : "transparent" }}
                                                        onClick={() => setTempSelectedIncomeClients(prev => isSelected ? prev.filter(c => c.id !== client.id) : [...prev, client])}>
                                                        <Checkbox size="small" checked={isSelected} onChange={() => {}} sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }} />
                                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500 }}>{client.FirmName}</Typography>
                                                    </Box>
                                                );
                                            })}
                                        </>
                                    )}
                                </Box>
                            </Box>

                            {/* ── Expense Accounts Clients ── */}
                            <Box>
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Expense Accounts Clients
                                </Typography>
                                <TextField fullWidth size="small" placeholder="Search expense clients..." value={expenseClientSearchText || ""} onChange={(e) => setExpenseClientSearchText(e.target.value)} sx={inputSx} InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                        Select Expense Clients ({(tempSelectedExpenseClients || []).length} / {(allExpenseAccountClients || []).length})
                                    </Typography>
                                </Box>
                                <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "8px", background: BG, maxHeight: 200, overflowY: "auto" }}>
                                    {expenseClientsLoading ? (
                                        <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                            <CircularProgress size={14} sx={{ color: FB }} />
                                            <Typography sx={{ fontSize: 12, color: T2 }}>Loading…</Typography>
                                        </Box>
                                    ) : (
                                        <>
                                            <Box sx={{ display: "flex", alignItems: "center", px: 1.25, py: "8px", borderBottom: `1px solid ${BORDER}`, background: FB_LIGHT, position: "sticky", top: 0, zIndex: 1 }}>
                                                <Checkbox size="small"
                                                    checked={(tempSelectedExpenseClients || []).length === filteredExpenseClients.length && filteredExpenseClients.length > 0}
                                                    indeterminate={(tempSelectedExpenseClients || []).length > 0 && (tempSelectedExpenseClients || []).length < filteredExpenseClients.length}
                                                    onChange={() => {
                                                        if ((tempSelectedExpenseClients || []).length === filteredExpenseClients.length) {
                                                            setTempSelectedExpenseClients([]);
                                                        } else {
                                                            setTempSelectedExpenseClients([
                                                                ...(tempSelectedExpenseClients || []),
                                                                ...filteredExpenseClients.filter(c => !(tempSelectedExpenseClients || []).some(s => s.id === c.id)),
                                                            ]);
                                                        }
                                                    }}
                                                    sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, "&.MuiCheckbox-indeterminate": { color: FB }, p: "4px" }}
                                                />
                                                <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>Select All ({filteredExpenseClients.length})</Typography>
                                            </Box>
                                            {filteredExpenseClients.length === 0 ? (
                                                <Box sx={{ px: 2, py: 2, textAlign: "center" }}><Typography sx={{ fontSize: 12, color: T2 }}>No clients found</Typography></Box>
                                            ) : filteredExpenseClients.map((client) => {
                                                const isSelected = (tempSelectedExpenseClients || []).some(c => c.id === client.id);
                                                return (
                                                    <Box key={client.id} sx={{ display: "flex", alignItems: "center", px: 1.25, py: "6px", cursor: "pointer", "&:hover": { background: FB_LIGHT }, borderBottom: `0.5px solid ${BORDER}`, background: isSelected ? FB_LIGHT : "transparent" }}
                                                        onClick={() => setTempSelectedExpenseClients(prev => isSelected ? prev.filter(c => c.id !== client.id) : [...prev, client])}>
                                                        <Checkbox size="small" checked={isSelected} onChange={() => {}} sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px" }} />
                                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500 }}>{client.FirmName}</Typography>
                                                    </Box>
                                                );
                                            })}
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </>
                    )}

                    {/* ── General Ledger: Client dropdown (same look as Book Name) — "Select All" when none
                        selected; the search box + client list open inside the dropdown ── */}
                    {showClientSection && (
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }} >
                                <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".3px", textTransform: "uppercase" }}>
                                    Clients ({tempSelectedClients.length} / {allClients.length})
                                </Typography>

                                {tempSelectedClients.length > 0 && (
                                    <Typography onClick={() => handleTempDeselectAll()}
                                        sx={{ fontSize: 11, color: FB, fontWeight: 500, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
                                    >
                                        Clear
                                    </Typography>
                                )}
                            </Box>

                            <FormControl fullWidth size="small">
                                <Select multiple displayEmpty value={tempSelectedClients.map((c) => c.id)}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return (
                                                <Typography sx={{ color: T2, fontSize: 13 }} >
                                                    Select All
                                                </Typography>
                                            );
                                        }

                                        return (
                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} >
                                                {tempSelectedClients.map((client) => (
                                                    <Chip key={client.id} label={client.FirmName} size="small" sx={{ height: 22, fontSize: 11, background: FB_LIGHT, color: FB, border: `1px solid ${G300}` }} />
                                                ))}
                                            </Box>
                                        );
                                    }}
                                    sx={selectSx}
                                    MenuProps={{
                                        autoFocus: false,
                                        PaperProps: {
                                            sx: { maxHeight: 320, borderRadius: "10px", border: `1px solid ${BORDER}` }
                                        }
                                    }}
                                    onClose={() => setTempClientSearchText("")}
                                >
                                    {/* Search box — filters the list below as the user types */}
                                    <ListSubheader sx={{ background: WHITE, lineHeight: "normal", py: 1 }}>
                                        <TextField fullWidth size="small" placeholder="Search by name, code, or contact..."
                                            value={tempClientSearchText}
                                            onChange={(e) => setTempClientSearchText(e.target.value)}
                                            onKeyDown={(e) => e.stopPropagation()}
                                            sx={inputSx}
                                            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T2 }} />, }} />
                                    </ListSubheader>

                                    {filteredTempClients.length === 0 ? (
                                        <MenuItem disabled>
                                            <Typography sx={{ fontSize: 12, color: T2 }}>No clients found</Typography>
                                        </MenuItem>
                                    ) : (
                                        filteredTempClients.map((client) => {
                                            const isSelected = tempSelectedClients.some((c) => c.id === client.id);
                                            return (
                                                <MenuItem key={client.id} value={client.id} onClick={() => handleTempClientCheckbox(client)}>
                                                    <Checkbox size="small" checked={isSelected}
                                                        sx={{ color: FB_MID, "&.Mui-checked": { color: FB }, p: "4px", mr: 1 }} />
                                                    <Typography sx={{ fontSize: 13, color: T1, fontWeight: 500 }}>
                                                        {client.FirmName}
                                                    </Typography>
                                                </MenuItem>
                                            );
                                        })
                                    )}
                                </Select>
                            </FormControl>
                        </Box>
                    )}

                    {/* ── Preview ── */}
                    {tempFromDate &&
                        tempToDate &&
                        (showBankFields ? !!selectedBankAccount : true) && (
                            <Box sx={{ background: FB_LIGHT, border: `1px solid ${G300}`, borderRadius: "10px", p: "10px 14px", display: "flex", flexDirection: "column", gap: "6px" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 600, color: G500, textTransform: "uppercase", letterSpacing: ".3px" }}>Preview</Typography>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
                                        <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
                                        <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>{REPORT_TYPES.find((r) => r.value === tempReportType)?.label}</Typography>
                                    </Box>
                                    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
                                        <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
                                        <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>{fmtDate(tempFromDate)} – {fmtDate(tempToDate)}</Typography>
                                    </Box>
                                    {showClientSection && (
                                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB }} />
                                            <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
                                                {tempSelectedClients.length > 0
                                                    ? `${tempSelectedClients.length} client${tempSelectedClients.length > 1 ? "s" : ""}`
                                                    : "All clients"}
                                            </Typography>
                                        </Box>
                                    )}

                                    {selectedBookNames.length > 0 && (
                                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }} >
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
                                            <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
                                                {selectedBookNames.length === 1 ? selectedBookNames[0] : `${selectedBookNames.length} books`}
                                            </Typography>
                                        </Box>
                                    )}

                                    {showBankFields && selectedBankAccount && (
                                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "3px", background: WHITE, border: `1px solid ${G300}`, borderRadius: "20px" }} >
                                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", background: FB, }} />
                                            <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB }}>
                                                {bankAccounts.find((a) => a.id === selectedBankAccount)?.AccountName || 'Bank Account'}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        )}
                </Box>
            </DialogContent>

            {/* ── Dialog Actions ── */}
            <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
                <Button onClick={onClose} sx={btnGhostSx} fullWidth>
                    Cancel
                </Button>
                <Button onClick={onGetData} disabled={isGetDataDisabled}
                    startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
                    sx={btnPrimarySx} fullWidth
                >
                    Get Data
                </Button>
            </DialogActions>
        </Dialog>
    );
}
